export default "__VITE_ASSET__DbnFbvdz__"